import typography from 'assets/theme/base/typography';
import colors from 'assets/theme/base/colors';

const { size } = typography;
const { common } = colors;

const dialogContentText = {
    styleOverrides: {
        root: {
            fontSize: size.md,
            color: common.white,
        },
    },
};

export default dialogContentText;
